import storeModule from '../store-module'
import { defineStore } from 'pinia'

const url = 'settings/tags'

export default defineStore(
  'tags',
  storeModule.createStoreModule('tags', {
    createURL: url,
    fetchListURL: url,
    fetchSingleURL: ({ id }) => id ? `${url}/${id}` : `${url}/new`,
    updateURL: ({ id }) => `${url}/${id}`,
    destroyURL: ({ id }) => `${url}/${id}`
  })
)
